import React from 'react';
// 1. Import both images
import foodCertImg from '../Assets/Aicte/FOODSAFETYCERTIFICATE1.jpg'; 
import foodIdImg from '../Assets/Aicte/FOODSAFETYCERTIFICATEId.jpg'; // Adjust name if different

const FoodSafety = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Blue Header Banner */}
      <div className="bg-[#1a3683] py-12 px-4 text-center text-white shadow-md">
        <h1 className="text-3xl md:text-5xl font-bold uppercase tracking-wide">
          Food Safety & Certificates
        </h1>
        <p className="mt-2 text-sm md:text-lg italic font-light opacity-90 max-w-3xl mx-auto">
          Transparency and Governance details of Sri Jyothi Polytechnic, Kalavapamula
        </p>
      </div>

      {/* Content Section */}
      <div className="max-w-6xl mx-auto py-12 px-6">
        
        {/* Grid Layout for Certificate and ID Card */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          
          {/* Left Side: Main Registration Certificate */}
          <div className="flex flex-col items-center">
            <h2 className="text-xl font-bold text-[#1a3683] mb-4 border-b-2 border-blue-800 pb-1 self-start">
              Registration Certificate
            </h2>
            <div className="bg-white p-4 shadow-xl rounded-sm border border-gray-200 hover:shadow-2xl transition-shadow duration-300">
              <img 
                src={foodCertImg} 
                alt="Food Safety Registration Certificate" 
                className="w-full h-auto"
              />
            </div>
          </div>

          {/* Right Side: Registration ID Card */}
          <div className="flex flex-col items-center">
            <h2 className="text-xl font-bold text-[#1a3683] mb-4 border-b-2 border-blue-800 pb-1 self-start">
              Registration ID Card
            </h2>
            <div className="bg-white p-4 shadow-xl rounded-sm border border-gray-200 hover:shadow-2xl transition-shadow duration-300">
              <img 
                src={foodIdImg} 
                alt="Food Safety Registration ID Card" 
                className="w-full h-auto"
              />
            </div>
            {/* Optional: Descriptive text for the ID Card */}
            <p className="mt-4 text-sm text-gray-500 italic text-center">
              FSSAI Registration ID: 20126121000177 <br/>
              Valid Upto: 12-03-2027
            </p>
          </div>

        </div>

        {/* Footer Notice */}
        <div className="mt-16 p-6 bg-blue-50 rounded-lg border border-blue-100 text-center">
          <p className="text-gray-700 font-medium">
            Certified by Food Safety and Standards Authority of India (FSSAI)
          </p>
        </div>
      </div>
    </div>
  );
};

export default FoodSafety;